
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqsjtHxe_eZ5bFZ1Xsd3FyjOc4tknsgb8hXax0ujT7FTEMeta } from "/codebuild/output/src4138564007/src/src/pages/faq.vue?macro=true";
import { default as menuAaz9A2s19NcGEypkP2AnVY9JEM2D1tH4RdC_5KQnLooMeta } from "/codebuild/output/src4138564007/src/src/pages/menu.vue?macro=true";
import { default as indexh3_45hjOHqysrdD_eXA0hiwajSD7eIPt_7V5q3eUaNCfMMeta } from "/codebuild/output/src4138564007/src/src/pages/index.vue?macro=true";
import { default as contactQgBjhK8rDuar3wJ5IWMGZfjnS29RbBr7GyO_455EsoTY8Meta } from "/codebuild/output/src4138564007/src/src/pages/contact.vue?macro=true";
import { default as tutorialiCByxdiW4W7gdAo5I4LXgGuvLfVadHrgP_8T9DpawOQMeta } from "/codebuild/output/src4138564007/src/src/pages/tutorial.vue?macro=true";
import { default as agreement1qIU_45AxZwLt8F0TyS9SL6C4bRuGJuhPyYpyPdZWQEcYMeta } from "/codebuild/output/src4138564007/src/src/pages/agreement.vue?macro=true";
import { default as about_45passdiqYGCVGkzrW3GsP3YpZrEbFKO_45NucswLny19HAldGYMeta } from "/codebuild/output/src4138564007/src/src/pages/about-pass.vue?macro=true";
import { default as indexuAB0s_45JwSznTjyVbWN5lUU8mmIN0BSAXrVhF_45Dz_45qdQMeta } from "/codebuild/output/src4138564007/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93B45Y1JbLFpko_uV7mf_45rXq_45IH2aF4ISnPRA_45ZTrO9AUMeta } from "/codebuild/output/src4138564007/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceqv4aEShSPWO9uBF7P3JKtVLm8C1LiwoSCo7RTVr9FY4Meta } from "/codebuild/output/src4138564007/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93kV8bHx1m5J_i5ZAEF4aiPAd88pm7sGMVOne6LZ_8TFQMeta } from "/codebuild/output/src4138564007/src/src/pages/notice/[id].vue?macro=true";
import { default as indexjDD00M4AjVLTnO8o7YIZ5LWYcJU8EPt7QggdN7dx2PoMeta } from "/codebuild/output/src4138564007/src/src/pages/coupon/index.vue?macro=true";
import { default as indexttBoAPdqyWY0WpA0hYUHxHAfZy68mi7LBQI_45YjT0zQQMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/index.vue?macro=true";
import { default as indexW3hBvjxiZ38TQfR73yf6bUeUNQtJiS__45uDTU28Zs8L4Meta } from "/codebuild/output/src4138564007/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93m7kGubVUNxDUXYO_45ddO5_45ffcF4uZdtrEmbyeE7Bl0VcMeta } from "/codebuild/output/src4138564007/src/src/pages/parking/[id].vue?macro=true";
import { default as indexzDCTwsoYEkWVHE4rfadPlrysSBuIOdEdyRliAtkwxE4Meta } from "/codebuild/output/src4138564007/src/src/pages/history/index.vue?macro=true";
import { default as indexhIpeRxRYrRXZ5mFvMhiRTytVMnMCsb3uyVA_jCCw_45fsMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/index.vue?macro=true";
import { default as indexNV92LyP4_wlMS8hED2JL7rzPuxoCpmJ_45KhjbDlV_NNgMeta } from "/codebuild/output/src4138564007/src/src/pages/sign-in/index.vue?macro=true";
import { default as index6_zSgbhWjazbCTquwrKDgnIYaZUIaemFuAiQdElsuxoMeta } from "/codebuild/output/src4138564007/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavittclP_45QQVpUajN5vCpirW_2ShhjbPrj2PlQy0EmvTVwMeta } from "/codebuild/output/src4138564007/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editDuLChRDTd43wsr4XO8bU2hEi0v5bfi692MII_tO6fuQMeta } from "/codebuild/output/src4138564007/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementssUzgIm82OOwvk0kON8iLniG4_45Df6qgIeO5UhmCZ2_450Meta } from "/codebuild/output/src4138564007/src/src/pages/pass-agreement.vue?macro=true";
import { default as index_45ujp4eUex3oiYH_457sgbHrAnRTLFR7OLJmt11ove1XzIMeta } from "/codebuild/output/src4138564007/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dJKGF0acPeuVKGPwtFNQrrfJpPL8EWNzQ_XKPTr5QeNEMeta } from "/codebuild/output/src4138564007/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmgUlnCqiY8QvYaYxBGW0kQ68_45Mp6bp2CRNgRceXwzlGgMeta } from "/codebuild/output/src4138564007/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexLjWwkQrVdVKaRWZ5olgBJlQTZGWVN_45DKtPkzEhUhoF4Meta } from "/codebuild/output/src4138564007/src/src/pages/card/create/index.vue?macro=true";
import { default as indexZjg_tgHEDwyCDTof_FFSaMKM35D6Sd5twGqODmGpz3cMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm_Cs2vleQqfKBZt82OA3NGOAvsL_6fOhweR9ASYZLSGUMeta } from "/codebuild/output/src4138564007/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmB_JBEVZda07raLDNu86ToRqmYOYk0PFKBuNWYQeWL_AMeta } from "/codebuild/output/src4138564007/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completewUT7rwtrnfDpg8Nsj5gPE11UugFzf_Qn2q0HZo1dNR0Meta } from "/codebuild/output/src4138564007/src/src/pages/membership/complete.vue?macro=true";
import { default as registeru9n2GY9YEtLiX_hZFHozaqrA95k58yB_45eiVpO4yIAUUMeta } from "/codebuild/output/src4138564007/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_936fe1dPd0vPsHTtGDQs_0N07tBvfZXgVEtvedTPUcYp4Meta } from "/codebuild/output/src4138564007/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm2vDEFGS9ea272tlncpbvBq1b7LX6MLXdjX7WPpQziaMMeta } from "/codebuild/output/src4138564007/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93MjdfRUmCJf4_jJ8ZZt0KQHciC123u3jGgKTdA5me4joMeta } from "/codebuild/output/src4138564007/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexKyyjiHNSqVzlmtxXDSHohtsE9jnXQcygeF9f97Xfzh4Meta } from "/codebuild/output/src4138564007/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code2qv8ViMW8JzCP21oPOCxY_a9D7GwvoTybj5pikMV0IoMeta } from "/codebuild/output/src4138564007/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codexraE01rIBU9BerLg85PmEY0VCX4EmPbLibM4OpOyT4cMeta } from "/codebuild/output/src4138564007/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeed2hL47vizDz49SaerlFl0bhab7vh9ZrstGs2z0ucd8Meta } from "/codebuild/output/src4138564007/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerhpuJkBP_4qSOAt_Uwa_kJrdHLp6_RAllRjyXbzv8zzMMeta } from "/codebuild/output/src4138564007/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete0AgNswmJVqq6dH4k8v603kUik5uAvJJ9lG1nxjk_45Tc0Meta } from "/codebuild/output/src4138564007/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexxpsIvUEqvjmeQf3T3atkhwrEKtUbQ_45tlEUw0kKsYBLUMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmRnVUmR1vjBbyP5KN3styE_Ez6PMcz76zNYtFY0Av4qAMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete3jnInjfHp658XUFdeDqFtiHLT9BFe9lPpiS6rNTBkMcMeta } from "/codebuild/output/src4138564007/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexGobH34h09lqIjs5hKuaup6Lj8GqvqMogMlhJRItxiGMMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93JHV_45vnPiBi28pfXqyRDZSH2KHW8c4i4Z6dluIaRDkQsMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completewNhPi_Uob487_45w4y_gxiU2F0HevvOUY7ABI_OWOp90UMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliastP6UspJmGolKVmbcruCSsZaNuBvNUHXiadM5PANRrecMeta } from "/codebuild/output/src4138564007/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleVGil1Y7MYKqM7_45Ke6fVBPB4JCmgH1wZAJxwd4F7G2qAMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailyjvrKViZcuUiFH8rt06tGjd3e_45Z5ySyiWloRI3KObe0Meta } from "/codebuild/output/src4138564007/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmQOEJMaZnIt3dmg2BeBg_45LojKJDK332NxvziUiwtFSfwMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentSDY26tQOMPUM8k8En8vwUNZw_45eOdCKQ2Dcfqe9RXcpwMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmnyPb2QHabp8VoYe963F5gKdWToFK85yRSfH4b7MUHYsMeta } from "/codebuild/output/src4138564007/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateRWv_hvSDDucgszP52SiU__45QoIGsGu_45RhcD6fM3RjOy0Meta } from "/codebuild/output/src4138564007/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeK_gg3B8_xqpLOFt5eQgr_45tDdFBn2ShX9s2Gw1gvJBQcMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codegaplsQjp6MWcDOW3aeAjK2QnES8YXmDztN_FK_YY_45MkMeta } from "/codebuild/output/src4138564007/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordfoMIVz68ks_0iqME2FSpyNzAtkA2mLtCCru8RiCf2jwMeta } from "/codebuild/output/src4138564007/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias0jQYPW6yBag7iQWZY4EOCN_lRQO0fJF8lzZMJybjCMEMeta } from "/codebuild/output/src4138564007/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerP51ShAl80ztJ_dgVJ7VN6Y_45ItjTe0ZC18UgblO_45_fSIMeta } from "/codebuild/output/src4138564007/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code9Qx_dWZhGIgk1_tM1c58beKfcXm5W4c3ig4ij5vEkfgMeta } from "/codebuild/output/src4138564007/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index2_45WXNmC4_45Bd0K7evvMc5hCBy77_fJYSIIjXPQTTRwe0Meta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexZmgj1j3xuXYChDcl1B1_45CM5etdJ5l942qqZTkxG_45BQgMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index7M_45tu6hfJHBDMzuBulVt0iXnrjGgvKEBL_451zp2aUWx8Meta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index0Z0ypHw7XseuNYOcfbIdX4lroN_CdGQZukwDr9S4smAMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateEw6_0kN0ESKVCZyWtiDGaLNuIPkNjmwjag74d_fGIswMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completelbkBuOoCZiD0vn6ThPA25UBaJT46JM9YXeKYAivDA_45EMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmvIW6OhCkd7fFtx_45YFtfrgGmSHIviFZvTc_459yAUNjhyMMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexKn8LqxBJKWKXc13LlGc_yHStVghOSoaR3E75xFcXrlgMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeFPw0wbX3TLoyv9fnRubf_aMFR_45Q9656WEG6EM4YvhGoMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateBORaLio3JWz2npg2QmAwln2A_45Ujik1MvmMMYhct_45CdQMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexEskytEjgDTFyf9FgP3jlFgTcbX4yUBpqOXHwdOlfWwEMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexx7qyZl_z6Eds67Q_45jb8KgfJilVvk44hXwRK5ilS6rvcMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeGeR2NQkaWTyjd_45dkq4aracWb072uVohSY2geplSLczYMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexOU9sieeVDCWHv4jsBPvhe7OEaSan4J_Kn6yjIg3TTVoMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeOYacVb8aifFqvN1tGURwNfSPpIF1s_mJYoKkmOs7SewMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexiR7Xsgu8KQq_45IUgrLvOy0QHxStZxEMSBG0lHdJdA3u8Meta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexqEOQhDAl6hUANEKT1XO__45c0f2_45K8ecY8b3gp_uBbRPkMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexxkbFh_45mBPvioF47tMAMMUzqQK85Zi5VqtYI6x7BKLvoMeta } from "/codebuild/output/src4138564007/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateBsxAigHpQ84nky0zTr_45hSNQY4BeiySdRwg3IH3eTUtkMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmo_45N1GoDHXzkU8WjJXZTCTtns1IbBb3LoRzRWjzmRRukMeta } from "/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuAaz9A2s19NcGEypkP2AnVY9JEM2D1tH4RdC_5KQnLooMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexh3_45hjOHqysrdD_eXA0hiwajSD7eIPt_7V5q3eUaNCfMMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexjDD00M4AjVLTnO8o7YIZ5LWYcJU8EPt7QggdN7dx2PoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexzDCTwsoYEkWVHE4rfadPlrysSBuIOdEdyRliAtkwxE4Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexNV92LyP4_wlMS8hED2JL7rzPuxoCpmJ_45KhjbDlV_NNgMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index6_zSgbhWjazbCTquwrKDgnIYaZUIaemFuAiQdElsuxoMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexLjWwkQrVdVKaRWZ5olgBJlQTZGWVN_45DKtPkzEhUhoF4Meta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm_Cs2vleQqfKBZt82OA3NGOAvsL_6fOhweR9ASYZLSGUMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmB_JBEVZda07raLDNu86ToRqmYOYk0PFKBuNWYQeWL_AMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completewUT7rwtrnfDpg8Nsj5gPE11UugFzf_Qn2q0HZo1dNR0Meta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeru9n2GY9YEtLiX_hZFHozaqrA95k58yB_45eiVpO4yIAUUMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm2vDEFGS9ea272tlncpbvBq1b7LX6MLXdjX7WPpQziaMMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code2qv8ViMW8JzCP21oPOCxY_a9D7GwvoTybj5pikMV0IoMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codexraE01rIBU9BerLg85PmEY0VCX4EmPbLibM4OpOyT4cMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeed2hL47vizDz49SaerlFl0bhab7vh9ZrstGs2z0ucd8Meta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerhpuJkBP_4qSOAt_Uwa_kJrdHLp6_RAllRjyXbzv8zzMMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmRnVUmR1vjBbyP5KN3styE_Ez6PMcz76zNYtFY0Av4qAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete3jnInjfHp658XUFdeDqFtiHLT9BFe9lPpiS6rNTBkMcMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexGobH34h09lqIjs5hKuaup6Lj8GqvqMogMlhJRItxiGMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completewNhPi_Uob487_45w4y_gxiU2F0HevvOUY7ABI_OWOp90UMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleVGil1Y7MYKqM7_45Ke6fVBPB4JCmgH1wZAJxwd4F7G2qAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailyjvrKViZcuUiFH8rt06tGjd3e_45Z5ySyiWloRI3KObe0Meta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmQOEJMaZnIt3dmg2BeBg_45LojKJDK332NxvziUiwtFSfwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentSDY26tQOMPUM8k8En8vwUNZw_45eOdCKQ2Dcfqe9RXcpwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmnyPb2QHabp8VoYe963F5gKdWToFK85yRSfH4b7MUHYsMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeK_gg3B8_xqpLOFt5eQgr_45tDdFBn2ShX9s2Gw1gvJBQcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codegaplsQjp6MWcDOW3aeAjK2QnES8YXmDztN_FK_YY_45MkMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordfoMIVz68ks_0iqME2FSpyNzAtkA2mLtCCru8RiCf2jwMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerP51ShAl80ztJ_dgVJ7VN6Y_45ItjTe0ZC18UgblO_45_fSIMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code9Qx_dWZhGIgk1_tM1c58beKfcXm5W4c3ig4ij5vEkfgMeta || {},
    component: () => import("/codebuild/output/src4138564007/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4138564007/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]